import { DOCUMENT } from '@angular/common';
import { Directive, Host, Inject, Input, Self } from '@angular/core';

import { RtTextInput } from '@core/user-interface-legacy';

import type { PlaceholderConfigMap } from './placeholder';

@Directive({
  selector: '[insertPlaceholderInput]',
  exportAs: 'placeholderInput',
  standalone: true,
})
export class InsertPlaceholderInputDirective {
  @Input() public placeholdersConfig: PlaceholderConfigMap = {};

  constructor(
    @Host() @Self() public input: RtTextInput,
    @Inject(DOCUMENT) private doc: Document,
  ) {}

  public insert(text: string): void {
    this.input.insertAtCaret(text, 'placeholder');
  }
}
